import React, { useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import { Col, Container, Row } from "reactstrap";

import ieltsImage from "../../../assets/kangaroo/ieltsprep.png";
import pearsonImage from "../../../assets/kangaroo/pearson.png";
import toeflImage from "../../../assets/kangaroo/toefl.png";
import duolingoImage from "../../../assets/kangaroo/duolingo.png";
import greImage from "../../../assets/kangaroo/gre.png";
import satImage from "../../../assets/kangaroo/sat.png";
import gmatImage from "../../../assets/kangaroo/gmat.png";
import Button from "../../../component/button/Button";
import Page8 from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import { useNavigate } from "react-router-dom";
import FormGoldBg from "../../../component/FormCloseGold/FormGoldBg";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import InlineForm from "../../../component/InlineForm/InlineForm";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import axios from "axios";
import TestPreparationService from "../../../services/TespreparationService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";

const TestPreparation = () => {
  const navigate = useNavigate();
  const [thankYouModal, setThankYouModal] = useState(false);

  const toggleThankYou = () => setThankYouModal(!thankYouModal);

  const testPreps = [
    { id: 1, img: ieltsImage, route: "/testprep/ielts" },
    { id: 2, img: pearsonImage, route: "/testprep/ielts" },
    { id: 3, img: toeflImage, route: "/testprep/ielts" },
    { id: 4, img: duolingoImage, route: "/testprep/ielts" },
    { id: 5, img: satImage, route: "/testprep/ielts" },
    { id: 6, img: greImage, route: "/testprep/ielts" },
    { id: 7, img: gmatImage, route: "/testprep/ielts" },
  ];
  const fetchData = async () => {
    const response = await TestPreparationService.getList();
    return response?.items
  }
  const { isPending, error, data: testPrepData } = useQuery({
    queryKey: ['testPrepData'],
    queryFn: fetchData,
  })

  if (isPending) return <div>Loading...</div>
  if (error) return <div>Error: {error.message}</div>
  return (
    <>
      <SectionContainer>
        <Container fluid className="p-0 m-0">
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "TEST PREPARATION" },
            ]}
            instituition={false}

          />

          <Row className="mb-5">
            <Col>
              <h1 className="lh-1 font-level-4 fw-normal text-start p-0 mt-3" >
                YOUR PATH TO  WORLD CLASS TEST <br /> PREPARATION STARTS
                HERE
              </h1>
            </Col>
          </Row>
          
              <Row className="g-3 m-0 p-0  justify-content-center justify-content-lg-start ">
                {testPrepData?.map((item) => (
                  <Col
                    xs={12}
                    sm={6}
                    md={6}
                    lg={4}
                    key={item.id}
                    className="d-flex justify-content-center" style={{marginTop:"2rem"}}
                  >
                    <div
                      className="position-relative rounded-5 mx-auto"
                      style={{
                        height: "clamp(200px, 40vw, 360px)",
                        width: "clamp(200px, 40vw)",
                        overflow: "hidden",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        cursor: "pointer",
                        border: "1px solid #ACA4A4"
                      }}
                      onClick={() => navigate(`/test-preparation/${item?.slug}`)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <img
                        src={`${imageBaseApi}${item.logoMedia?.url}`}
                        loading="lazy"
                        alt={`Test Prep ${item.id}`}
                        className="w-100 h-100"
                        style={{ objectFit: "contain" }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
           
        </Container>
      </SectionContainer>

      <SectionContainer mainId="ielts-prep-subpage" style={{ marginTop: "12.4rem", marginBottom: "12.4rem" }}>
        <Row style={{ marginTop: "0rem" }}>
          <Col>
            <h1 className="font-heading">
              Start Smart With Expert Test Preparation Classes & Guidance
            </h1>
            <p className="country-paragraph-text mt-3 mb-4">
              Fill in the details below, and our test preparation advisors
              will guide you toward the right preparation plan and class for
              your goals.
            </p>
          </Col>
        </Row>

        <DynamicInlineForm
          fullName={true}
          email={true}
          phone={true}
          testPrepClasses={true}
          callBackTime={true}
          preferedBranchId={true}
          message={true}
          buttondesc="BOOK YOUR CLASS"
          closingFormat="gold"
          formOrigin={8}
          btnTestPrep={true}
        />

      </SectionContainer>
      <FormGoldBg
        modal={thankYouModal}
        toggle={toggleThankYou}
        heading="YOU'RE ONE STEP CLOSER TO STARTING SMART"
        description="Our team will connect with you shortly"
      />

      {/* <SectionContainer>
        <DynamicInlineForm
          fullName={true}
          emailAddress={true}
          phoneNumber={true}
          testPrepClasses={true}
          callBackTime={true}
          nearestOffice={true}
          message={true}
          buttondesc="BOOK YOUR CLASS"
        />
      </SectionContainer> */}

      <SectionContainer mainId="test-prep-subpage-margin">
        <div className="page-content">
          <Page8 />
        </div>
        <hr className="line-style-testprep" />
      </SectionContainer>

      <SectionContainer>
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default TestPreparation;
